import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import { articleList } from "@/mocks/articles";

const categories = Array.from(new Set(articleList.map((a) => a.category)));

export default function NewsList() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(
    () => (active === "全部" ? articleList : articleList.filter((a) => a.category === active)),
    [active]
  );

  return (
    <>
      <Seo
        title="漫画资讯与专题 - 樱花漫画"
        description="汇聚国漫漫评盘点、创作干货与行业观察的深度资讯平台，为你提供有价值的漫画阅读内容。"
        canonical="https://comicflower.github.io/news"
      />
      <div className="mx-auto max-w-7xl px-4 pt-24 md:px-6 md:pt-28">
        <nav className="flex flex-wrap items-center gap-1 text-xs text-foreground-500" aria-label="面包屑">
          <Link to="/" className="hover:text-primary-700">首页</Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          <span className="text-foreground-800">资讯</span>
        </nav>
        <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">漫画资讯与专题</h1>
        <p className="mt-2 max-w-2xl text-sm text-foreground-600">
          漫评盘点、创作干货与行业观察，用有价值的深度内容，陪你更懂漫画。
        </p>

        <div className="mt-6 flex flex-wrap gap-2">
          {["全部", ...categories].map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {filtered.map((a) => (
            <Link
              key={a.id}
              to={`/news/${a.id}`}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[16/8] overflow-hidden">
                <img
                  src={a.cover}
                  alt={a.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  {a.category}
                </span>
              </div>
              <div className="p-5">
                <p className="text-xs text-foreground-500">
                  {a.date} · {a.readTime} 阅读 · {a.views} 次浏览
                </p>
                <h2 className="mt-2 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                  {a.title}
                </h2>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {a.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}